import { GetShareholderInvestmentEntryRes } from '@dealstack/shared/lib/generated';
import { FileExtension } from '@dealstack/shared/lib/common/dataExchange/common';

export const resolveFileExtension = (fileName: string): FileExtension | undefined => {
	const extension = fileName.split('.').pop()?.toLowerCase();

	return extension && extension in FileExtension
		? FileExtension[extension as keyof typeof FileExtension]
		: undefined;
};

export enum INVESTOR_WORKFLOW {
	KYC = 'KYC',
	JOINER_CREATE = 'JOINER_CREATE',
	ALLOCATION = 'ALLOCATION',
	JOINER = 'JOINER',
	LEAVER = 'LEAVER',
	DOCUMENT = 'DOCUMENT',
}

export const resolveInvestorWorkflow = (
	investment: Pick<GetShareholderInvestmentEntryRes, 'latestTransaction'>
): INVESTOR_WORKFLOW => INVESTOR_WORKFLOW[investment.latestTransaction.type];
